import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { AlertTriangle } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import { useAuth } from '../../contexts/AuthContext';
import { API } from '../../shared/config';

// Pop-up « Facture en attente de règlement » : affiché à chaque connexion / ouverture de l'application
// tant que la facture n'est pas marquée payée par le directeur (« J'ai compris » ne fait que le fermer).
export default function AlerteFactureImpayee() {
  const { user } = useAuth();
  const [factures, setFactures] = useState(null);

  useEffect(() => {
    if (!user) return;
    axios.get(`${API}/comptabilite/registre/alertes-impayes`)
      .then(r => { if (Array.isArray(r.data) && r.data.length) setFactures(r.data); })
      .catch(() => {});
  }, [user]);

  if (!user || !factures) return null;

  const fermer = () => setFactures(null);

  return (
    <Dialog open onOpenChange={(o) => { if (!o) fermer(); }}>
      <DialogContent className="max-w-2xl rounded-2xl p-8 sm:p-10 [&>button]:hidden" data-testid="alerte-facture-dialog">
        <div className="flex items-center gap-5">
          <div className="h-16 w-16 shrink-0 rounded-full bg-amber-100 flex items-center justify-center">
            <AlertTriangle className="h-8 w-8 text-amber-600" />
          </div>
          <DialogTitle className="text-2xl sm:text-3xl font-extrabold text-[#12295a] leading-tight" data-testid="alerte-facture-titre">
            Facture en attente de règlement
          </DialogTitle>
        </div>
        <DialogDescription asChild>
          <div className="mt-4 space-y-4 text-base sm:text-lg text-gray-600 leading-relaxed">
            <p>Merci de procéder au règlement de votre facture afin de permettre l'ouverture de vos vacations pour le mois prochain.</p>
            {factures.length > 0 && (
              <ul className="text-sm sm:text-base text-gray-500 space-y-1" data-testid="alerte-facture-liste">
                {factures.map(f => (
                  <li key={f.id}>
                    {f.numero_facture ? `N°${f.numero_facture} — ` : ''}{f.libelle || f.annee_mois}
                    {typeof f.montant_total === 'number' ? ` — ${f.montant_total.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })}` : ''}
                  </li>
                ))}
              </ul>
            )}
            <p>Ce message disparaîtra automatiquement dès réception du paiement.</p>
          </div>
        </DialogDescription>
        <div className="mt-6 flex justify-center">
          <button
            type="button"
            onClick={fermer}
            className="rounded-xl bg-[#1e3f7a] hover:bg-[#12295a] text-white text-lg font-semibold px-14 py-3 transition-colors"
            data-testid="alerte-facture-compris-btn"
          >
            J'ai compris
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
